export const ADFStages = {
	FINAL: 'final',
	STAGE_0: 'stage0',
} as const;
